module.exports = __webpack_public_path__ + "img/pl.3f40894f.jpg";